<template>
  <button
    ref="button"
    type="button"
    :class="`whitespace-nowrap ${cls}`"
    :disabled="busy || disabled"
  >
    <span v-if="busy">
      <IconLoader class="size-4 animate-spin" />
      {{ busyText }}
    </span>
    <slot v-else name="content"> Save </slot>
  </button>
</template>

<style lang="scss" scoped></style>

<script>
import IconLoader from '~icons/lucide/loader-circle';

export default {
  name: 'k-submit-button',
  components: {
    IconLoader,
  },
  props: {
    busy: {
      type: Boolean,
      required: true,
    },
    busyText: {
      type: String,
      default: 'Saving...',
    },
    cls: {
      type: String,
      default: 'btn btn-primary',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
